import React from "react";

export function PaginationSkeleton({
  className = "",
}: { className?: string }) {
  return (
    <nav aria-label="Pagination" role="status" aria-live="polite" className={`pgx-wrap ${className}`}>
      <ul className="pgx">
        <li className="pgx__item"><span className="pgx-sk pgx-sk--chev" /></li>
        <li className="pgx__item"><span className="pgx-sk pgx-sk--num" /></li>
        <li className="pgx__item"><span className="pgx-sk pgx-sk--current" /></li>
        <li className="pgx__item"><span className="pgx-sk pgx-sk--num" /></li>
        <li className="pgx__item"><span className="pgx-sk pgx-sk--num" /></li>
        <li className="pgx__item">
          <span className="pgx-dots"><i className="pgx-sk" /><i className="pgx-sk" /><i className="pgx-sk" /></span>
        </li>
        <li className="pgx__item"><span className="pgx-sk pgx-sk--num pgx-sk--wide" /></li>
        <li className="pgx__item"><span className="pgx-sk pgx-sk--num pgx-sk--wide" /></li>
        <li className="pgx__item"><span className="pgx-sk pgx-sk--chev" /></li>
      </ul>
    </nav>
  );
}

type PaginationProps = {
  current: number;
  total: number;
  onChange: (page: number) => void;
  className?: string;
};

// export function Pagination({
//   current, total, onChange, className = ""
// }: PaginationProps) {
//   const clamp = (n: number) => Math.max(1, Math.min(total, n));

//   const pages: (number | "...")[] = [];
//   pages.push(1);

//   const mids = [current, current + 1, current + 2].filter(p => p >= 2 && p <= total - 2);
//   for (const p of mids) if (!pages.includes(p)) pages.push(p);

//   if (pages[pages.length - 1] !== total - 2) pages.push("...");
//   pages.push(total - 1, total);

//   const unique = Array.from(new Set(pages)).sort((a, b) => {
//     if (a === "..." || b === "...") return 0;
//     return (a as number) - (b as number);
//   });

//   const final: (number | "...")[] = [];
//   for (let i = 0; i < unique.length; i++) {
//     const val = unique[i];
//     final.push(val);
//     const next = unique[i + 1];
//     if (typeof val === "number" && typeof next === "number" && next - val > 1) {
//       final.push("...");
//     }
//   }

//   return (
//     <nav aria-label="Pagination" className={`pgx-real ${className}`}>
//       <ul className="pgx-real__list">
//         <li><button className="pgx-real__btn" onClick={() => onChange(clamp(current - 1))} aria-label="Previous page">&lt;</button></li>
//         {final.map((item, idx) => (
//           <li key={`${item}-${idx}`}>
//             {item === "..." ? (
//               <span className="pgx-real__dots" aria-hidden="true">…</span>
//             ) : (
//               <button
//                 className={`pgx-real__btn ${item === current ? "is-current" : ""}`}
//                 aria-current={item === current ? "page" : undefined}
//                 onClick={() => onChange(item)}
//               >
//                 {item}
//               </button>
//             )}
//           </li>
//         ))}
//         <li><button className="pgx-real__btn" onClick={() => onChange(clamp(current + 1))} aria-label="Next page">&gt;</button></li>
//       </ul>
//     </nav>
//   );
// }
